let pass_reveal_button = document.querySelector(".user-pass-container button");
let pass_hide = document.querySelector(".user-pass-container .hide-pass");
let pass_field = document.querySelector(".user-pass-container input");
if(pass_reveal_button) {
  pass_reveal_button.addEventListener('click', (e) => {
    e.preventDefault();
    if(pass_field.getAttribute('type') === 'password') {
      pass_field.setAttribute('type', 'text');
      pass_hide.style.display = 'block';
    }
    else {
      pass_field.setAttribute('type', 'password')
      pass_hide.style.display = 'none';
    }
  });
}

// function waitForImage(imgElem) {
//     return new Promise(res => {
//         if (imgElem.complete) {
//             return res();
//         }
//         imgElem.onload = () => res();
//         imgElem.onerror = () => res();
//     });
// }
// const setCardHeights = async () => {
//   const cardImages = document.querySelectorAll('.product-slider-active .slick-slide img, .related-feature-product-slider-active img')
//   cardImages.forEach(item => {
//     const loadedImage = await waitForImage(item)
//     if (loadedImage) {
//       console.log(loadedImage)
//     }
//   })
  
//   const cardHeights = []
//   const cards = await document.querySelectorAll('.product-slider-active .slick-slide, .related-feature-product-slider-active')
//   cards.forEach(item => {
//     cardHeights.push(item.clientHeight)
//   })
//   const maxHeight = Math.max(...cardHeights)
//   document.querySelectorAll('.product-slider-active .slick-slide, .related-feature-product-slider-active .slick-slide').forEach(item => {
//     item.style.height = maxHeight + 'px'
//   })
//   document.querySelectorAll('.product-slider-active .slick-slide, .related-feature-product-slider-active .slick-slide').forEach(item => {
    
//     item.style.height = maxHeight + 'px'
//   })
// }
// window.addEventListener('load', setCardHeights);